















import _ from "lodash";
import InputField from "./InputField.vue";
import Multiselect from "vue-multiselect";
import { Config } from "../../utils/Config";
import { ListParamApi } from "../../api/ListParamApi";
import { Option } from "../../models/Option";

export default {
    name: "MaterielCategorieSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
        // Objet Option, ou simplement l'id de l'option (pratique en édition).
        value: [Object, Number],
        placeholder: {
            type: String,
            default: "Sélectionner une catégorie",
        },
    },
    data() {
        return {
            ListParamApi: new ListParamApi(),
            selected: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {
        let self = this;

        self.ListParamApi.getAll({
            type: Option.EListParamType.materiel_categorie,
        }).then(function (res) {
            self.options = res;
            self.$emit("options-loaded", self.options);
            self.applyValue();
        });
    },
    methods: {
        /**
         * Aligne la sélection sur la prop `value`, qui peut être une Option
         * complète ou un simple id.
         */
        applyValue: function () {
            if (this.value === null || this.value === undefined) {
                this.selected = null;
                return;
            }
            let id = _.isObject(this.value) ? this.value.id : this.value;
            let found = _.find(this.options, { id: parseInt(id, 10) });
            this.selected = found ? found : _.isObject(this.value) ? this.value : null;
        },
    },
    watch: {
        selected: function (newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }
            this.$emit("input", this.selected);
        },
        value: function () {
            this.applyValue();
        },
    },
};
